import React from 'react';
/**
 * Coming soon page component
 * Renders a placeholder message for features that are not yet implemented
 */
const ComingSoon = () => {
    return (React.createElement("div", { style: { color: 'grey' } },
        React.createElement("h2", null, "Coming Soon...")));
};
export { ComingSoon };
